import {Fragment} from 'react';
import {Col, Row, Button, Form, FormGroup, Label, Input} from 'reactstrap';

// Layout

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setRegisterFieldAction } from '../../../reducers/ui/register';
import { Link } from 'react-router-dom';
import { hasEmptyValue, showWarning } from '../../../utils/service';
import { apiRegisterUserAction } from '../../../sagas/apiCallSaga';

const mapStateToProps = store => ({
    state: store.ui.register,
})

const mapDispatchToProps = dispatch => (
    bindActionCreators({
        setField: setRegisterFieldAction,
        registerUser: apiRegisterUserAction,
    }, dispatch)
)

class RegisterBoxed extends Component {

    btnCreateClicked = () => {
        let { email, first_name, last_name, password, password_re } = this.props.state.registerInfo

        if (hasEmptyValue([email, first_name, last_name, password, password_re])) {
            showWarning("There are missing fields")
            return
        }

        if (password != password_re) {
            showWarning("Passwords don't match")
            return 
        }

        this.props.registerUser({
            email, first_name, last_name, password
        })
    }

    render() {

        let { registerInfo } = this.props.state
        let { setField } = this.props

        return (
            <Fragment>
                <div className="h-100 bg-premium-dark">
                    <div className="d-flex h-100 justify-content-center align-items-center">
                        <Col md="8" className="mx-auto app-login-box">
                            <div className="app-logo-inverse mx-auto mb-3"/>

                            <div className="modal-dialog w-100">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className="modal-title">
                                            <h4 className="mt-2">
                                                <div>Welcome,</div>
                                                <span>It only takes a <span className="text-success">few seconds</span> to create your account</span>
                                            </h4>
                                        </div>
                                        <Row className="divider"/>
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Input type="email"
                                                        placeholder="Email here..."
                                                        value={registerInfo.email}
                                                        onChange={e => setField("email", e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Input type="text"
                                                        placeholder="First name here..."
                                                        value={registerInfo.first_name}
                                                        onChange={e => setField("first_name", e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Input type="text"
                                                        placeholder="Last name here..."
                                                        value={registerInfo.last_name}
                                                        onChange={e => setField("last_name", e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Input type="password"
                                                        placeholder="Password here..."
                                                        value={registerInfo.password}
                                                        onChange={e => setField("password", e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Input type="password"
                                                        placeholder="Repeat Password here..."
                                                        value={registerInfo.password_re}
                                                        onChange={e => setField("password_re", e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {/*<FormGroup className="mt-3" check>
                                            <Input type="checkbox" name="check" id="exampleCheck"/>
                                            <Label for="exampleCheck" check>Accept our <a >Terms and
                                                Conditions</a>.</Label>
                                        </FormGroup>*/}
                                        <Row className="divider"/>
                                        <h6 className="mb-0">
                                            Already have an account?{' '}
                                            <Link to="/pages/login-boxed">Sign in</Link>
                                            {' '} | {' '}
                                            <Link to="/pages/forgot-password-boxed" className="text-primary">Recover Password</Link>
                                        </h6>
                                    </div>
                                    <div className="modal-footer d-block text-center">
                                        <Button color="primary" className="btn-wide btn-pill btn-shadow btn-hover-shine"
                                            size="lg"
                                            onClick={this.btnCreateClicked}
                                        >
                                            Create Account
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center text-white opacity-8 mt-3">
                                Copyright &copy; CyberSPF 2020
                            </div>
                        </Col>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterBoxed);